import { apiWobaInventory } from "@/services/api-woba-inventory";
import type {
  GetRoomPhotosApiParams,
  WobaInventoryRoomResponse,
  TransformedRoomData,
} from "./get-room-photos.types";

export const GetRoomPhotosApi = async (
  params: GetRoomPhotosApiParams,
): Promise<TransformedRoomData> => {
  const { id } = params;

  const response = await apiWobaInventory.get<WobaInventoryRoomResponse>(
    `/private-offices/${id}`,
  );

  const roomData = response.data;
  const metadata = roomData.metadata;

  const photoUrls = metadata.photos.map((photo) => photo.url);

  const pictures = photoUrls.slice(0, 6);

  return {
    id: roomData.id,
    label: metadata.name,
    picture_url: pictures[0] || null,
    picture_url1: pictures[1] || null,
    picture_url2: pictures[2] || null,
    picture_url3: pictures[3] || null,
    picture_url4: pictures[4] || null,
    picture_url5: pictures[5] || null,
    pictures: photoUrls,
    capacity: metadata.capacity,
    private_room_id: metadata.externalId,
    description: metadata.description,
    monthly_price: metadata.monthlyPrice,
    notes: metadata.notes,
    status: metadata.status,
  };
};
